import React from 'react';

import { Theme as ThemeProps } from '@nivo/core';
import { ResponsiveRadar } from '@nivo/radar';

import { colorsPalette } from '../../theme';

const theme: ThemeProps = {
  axis: {
    ticks: {
      text: {
        fill: colorsPalette.white,
        fontSize: 14,
      },
    },
  },
  grid: {
    line: {
      stroke: colorsPalette.graySaturated,
    },
  },
  crosshair: {
    line: {
      stroke: colorsPalette.white,
    },
  },
};

const LabelComponent = ({ id, anchor }) => {
  const words = id && id.split(' ');

  return (
    <text dominantBaseline="central" textAnchor={anchor} style={{ fill: colorsPalette.white }}>
      {words.length > 1 ? (
        words.map((item, index) => {
          if (index === 0) {
            return <tspan key={item}>{item}</tspan>;
          } else if (item.length < 3) {
            return <tspan key={item}> {item}</tspan>;
          }

          return (
            <tspan x="0" dy="1.2em" key={item}>
              {item}
            </tspan>
          );
        })
      ) : (
        <tspan key={words[0]}>{words[0]}</tspan>
      )}
    </text>
  );
};

const COLORS = ['#6869ED', '#E5BFEE', '#E6FB7A', '#F45B69', '#20A4F3', '#7EFCF0'];

const RadarChart = ({ data, keys }) => {
  const areDataValuesZero = data.every((item) => {
    return keys.every((key) => item[key] === 0 || item[key] === null || item[key] === undefined);
  });

  return (
    <ResponsiveRadar
      data={data}
      keys={keys}
      indexBy="category"
      maxValue={areDataValuesZero ? 1 : 'auto'}
      margin={{ top: 50, right: 0, bottom: 60, left: 0 }}
      curve="linearClosed"
      borderWidth={1}
      gridLevels={5}
      gridShape="circular"
      gridLabelOffset={35}
      enableDots={true}
      dotSize={5}
      dotColor={{ from: 'color', modifiers: [] }}
      dotBorderWidth={0}
      enableDotLabel={false}
      dotLabel="value"
      dotLabelYOffset={0}
      colors={COLORS}
      fillOpacity={0.25}
      blendMode="normal"
      animate={false}
      motionStiffness={90}
      motionDamping={15}
      isInteractive={true}
      theme={theme}
      // @ts-ignore
      gridLabel={LabelComponent}
    />
  );
};

export default RadarChart;
